import { TDeviceType } from '@cian/ui-kit';
import { IBuildersProjectsData } from '../../../shared/types/buildersProjects';
import { getAnalyticsPage, getAnalyticsProducts, getAnalyticsUser } from '../../../shared/utils/analytics';

interface ICreateCianAnalyticsPageViewObjectParams {
  buildersProjects?: IBuildersProjectsData;
  deviceType: TDeviceType;
  userId?: number;
  withUxfb?: boolean;
}

export function createCianAnalyticsPageViewObject({
  buildersProjects,
  deviceType,
  userId,
  withUxfb,
}: ICreateCianAnalyticsPageViewObjectParams) {
  return {
    page: getAnalyticsPage({ pageNumber: buildersProjects?.page, deviceType }),
    products: getAnalyticsProducts(buildersProjects),
    user: getAnalyticsUser({ userId, withUxfb }),
  };
}
